// extracted by mini-css-extract-plugin
module.exports = {"grid":"_3Arj8ltnzMUzRHHHFLB5iV"};